<template>
  <tr>
    <td class="pr-5 py-3 align-top">
      <button @click="showAdds" class="text-left lg:hover:underline lg:text-lg xl:pl-1 2xl:text-2xl">
        <span class="flex gap-2" title="Klick für Zutaten, Zusatzstoffe und Allergene"><span class="flex w-fit">{{ capitalizeFirstLetter(meal.title) }}</span> <Info class="min-w-5" size="20" stroke-width="1.5" /></span>
        <ul class="flex md:hidden gap-1 mt-2">
          <li v-for="(cat, index) in meal.categories" :key="index" :title="foodCatNames(cat, locale)">
            <component class="mx-auto w-6 h-auto lg:w-9" stroke-width="1.5" :is="resolveCatIcons(cat)" />
          </li>
        </ul>
      </button>
      <div ref="info" class="hidden pointer-events-none fixed top-0 left-0 w-full h-full z-20 flex items-center justify-center">
        <div @click="hideAdd" class="overlay fixed top-0 left-0 w-full h-full bg-slate-800/80 z-[21]"></div>
        <div class="z-[22] w-4/5 lg:w2/3 xl:w-1/2 shadow-sm flex flex-col bg-stw-grey-light p-5 rounded-md overflow-x-hidden overflow-y-auto border-stw-border border-[1.5px] lg:border-[2px]">
          <small class="mb-4 text-sm">
            {{ locale == 'de' ? 'Zusatzstoffe (Additives) und Allergene (Allergens) nach LMIV 1169/2011' : 'Additives and allergens according to LMIV 1169/2011' }}
          </small>
          <h4 class="font-bold text-base xl:text-xl mb-2">{{ capitalizeFirstLetter(meal.title) }}</h4>
          <h5 class="text-sm xl:text-lg mb-2">{{ locale == 'de' ? 'Zutaten:' : 'Ingredients:' }}</h5>
          <ul class="flex flex-col gap-2 text-base xl:text-lg">
            <li v-for="(ingr, index) in meal.ingredients.filter(ig => ig.label !== '')" :key="index">
              <label class="font-bold">{{ ingr.label }}</label>
              <ul v-if="ingr.additionals && ingr.additionals.length && ingr.additionals.filter(adt => adt !== '').length">
                <li v-for="(add, index) in filterAdds(ingr.additionals)" :key="index">- {{ addSwitch(add, locale) }}</li>
              </ul>
              <span v-else><br />- {{ locale == 'de' ? 'Keine Allergene oder Zusatzstoffe' : 'No allergens or additives' }}</span>
            </li>
          </ul>
          <button @click="hideAdd" class="mt-5 w-fit whitespace-nowrap flex text-xs items-center font-bold gap-4 px-8 h-8 rounded-full shadow-lg lg:hover:shadow-sm lg:hover:bg-stw-grey-dark lg:hover:text-white bg-red-700 text-white">
            <span>{{ locale == 'de' ? 'Schliessen' : 'Close' }}</span>
          </button>
        </div>
      </div>
    </td>
    <td class="px-2 py-3 align-top hidden md:table-cell">
      <ul class="flex gap-1">
        <li v-for="(cat, index) in meal.categories" :key="index" :title="foodCatNames(cat, locale)">
          <a v-if="cat == 'KT' && locale == 'en'" href="/en/canteen/klimateller/">
            <component :is="resolveCatIcons(cat)" />
          </a>
          <a v-else-if="cat == 'KT' && locale == 'de'" href="/de/essen-und-trinken/klimateller/">
            <component :is="resolveCatIcons(cat)" />
          </a>
          <span v-else>
            <component :is="resolveCatIcons(cat)" />
          </span>
        </li>
      </ul>
    </td>
    <td class="py-3 flex gap-4 lg:gap-10 align-top justify-between lg:text-base 2xl:text-xl">
      <span v-for="(price, index) in meal.prices.slice(0,2)" :key="index">
        <strong class="flex whitespace-nowrap">€{{ price.price.replace('.', ',') }}</strong>
        <small class="md:hidden">{{ price.label.substring(0,5) }}.</small>
        <small class="hidden md:inline">{{ price.label }}</small>
      </span>
    </td>
  </tr>
</template>

<script setup>
  import { ref } from "vue";
  import { addSwitch, foodCatNames, capitalizeFirstLetter } from "../../lib/menuHelper"
  import { Info }  from 'lucide-vue-next'
  import Beef from "../foodicons/Beef.vue"
  import Chicken from "../foodicons/Chicken.vue"
  import Vegan from "../foodicons/Vegan.vue"
  import Vegetarian from "../foodicons/Vegetarian.vue"
  import Fish from "../foodicons/Fish.vue"
  import Pork from "../foodicons/Pork.vue"
  import Animals from "../foodicons/Animals.vue"
  import Deer from "../foodicons/Deer.vue"
  import Sheep from "../foodicons/Sheep.vue"
  import Climate from "../foodicons/Climate.vue"

  const props = defineProps({
    meal: {
      type: Object,
      required: true,
    },
    locale: {
      type: String,
      required: true,
    }
  });

  const info = ref(null)

  const resolveCatIcons = (catNo) => {
    switch(catNo){
        case "R":
          return Beef;
          break;
        case "G":
          return Chicken;
          break;
        case "S":
          return Pork;
          break;
        case "F":
          return Fish;
          break;
        case "VT":
          return Vegetarian;
          break;
        case "VG":
          return Vegan;
          break;
        case "AT":
          return Animals;
          break;
        case "W":
          return Deer;
          break;
        case "L":
          return Sheep;
          break;
        case "KT":
          return Climate;
          break;
        default:
          return Beef;
    }
  }

  const filterAdds = (adds) => {
    const exclude = new Set(["S", "R", "G", "F", "MSC", "L", "W", "AT"])
    return adds.filter(item => !exclude.has(item))
  }

  const showAdds = () => {
    info.value.classList.toggle('hidden')
    info.value.classList.toggle('pointer-events-none')
  }
    
  const hideAdd = () => {
    info.value.classList.toggle('hidden')
    info.value.classList.toggle('pointer-events-none')
  }
</script>